import { IGroupAdminPermissionsParams } from "../hooks/defs/user-descendants";

import request from "../base-request";

export declare interface UserDescendantsData {
	descendants?: Array<string>;
}

export declare interface MembersUserIsGroupAdminOfData {
	groupAdminMembers?: Array<string>;
}

export const fetchUserDescendants = async () => {
	try {
		const [userDescendants] = await request<UserDescendantsData>(`/api/user-descendants/`);
		return userDescendants;
	} catch (error) {
		throw error;
	}
};

type IsUserInChainOfCommandData = {
	errors: string[];
	isManager: boolean;
};

export const fetchIsUserInChainOfCommand = async (userBeingViewedId: string) => {
	try {
		const [isUserInChainOfCommand] = await request<IsUserInChainOfCommandData>(
			`/chain-of-command/${userBeingViewedId}`
		);
		return isUserInChainOfCommand;
	} catch (error) {
		throw error;
	}
};

export const fetchMembersUserIsGroupAdminOf = async (groupAdminPermissions: IGroupAdminPermissionsParams) => {
	try {
		const { goals, feedback, reviews } = groupAdminPermissions;
		const queryString = new URLSearchParams();
		if (goals) queryString.append("goals", "true");
		if (feedback) queryString.append("feedback", "true");
		if (reviews) queryString.append("reviews", "true");

		const [membersUserIsGroupAdminOf] = await request<MembersUserIsGroupAdminOfData>(
			`/group-admin-members/${queryString.toString().length ? `?${queryString.toString()}` : ""}`
		);
		return membersUserIsGroupAdminOf;
	} catch (error) {
		throw error;
	}
};
